const bodyScrollLock = require('body-scroll-lock');

const handleCheckboxChange = function(checkboxElement) {
    if (checkboxElement.checked == true) {
        document.querySelectorAll('.mobile-menu__scroll-area').forEach(element => {
            bodyScrollLock.disableBodyScroll(element);
        })
        return;
    }
    document.querySelectorAll('.mobile-header-menu__sub-menu-checkbox').forEach(element => {
        element.checked = false;
    })
    document.querySelectorAll('.mobile-menu__scroll-area').forEach(element => {
        bodyScrollLock.enableBodyScroll(element);
    })
}

window.addEventListener("pagehide", event => {
    bodyScrollLock.clearAllBodyScrollLocks();
})

export default function() {
    const checkboxElement = document.querySelector('#mobile-header-menu__burger-checkbox');
    if (!checkboxElement) {
        return;
    }
    handleCheckboxChange(checkboxElement);
    checkboxElement.addEventListener('change', function() {
        handleCheckboxChange(checkboxElement);
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/mega-menu/mobile.js